// Global stylesheet
import { createGlobalStyle } from 'styled-components'
import styledNormalize from 'styled-normalize'

import { applyTextStyle } from './typography'
import { ITheme } from '../context/AppContext'

const GlobalStyle = createGlobalStyle<{ theme: ITheme }>`
  ${styledNormalize}

  html,
  body {
    width: 100%;
    height: 100%;
    color: black;
    font-family: 'Montserrat', sans-serif;
    ${applyTextStyle('body')}
  }

  * {
    box-sizing: border-box;
  }

  #root {
    width: 100%;
    height: 100%;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
  }


`

export default GlobalStyle
